/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button } from "react-blueprint-library";
import LostDataModal from "../../../../../../../SharedComponents/LostDataModal";
import "../../BankruptcyDisclosure.scss";
import { CCB_FORM_ID } from "../../../constants";
import NavigationButtons from "../../../../../../../SharedComponents/NavigationButtons";

const BankruptcyDisclosureComments = ({
  updateCCBForm,
  nextFormId,
  updateTempBankruptcyDRP,
  tempBankruptcyDRP,
  updateBankruptcyDisclosureDRPs,
  hasSIPA,
  hasCompromise,
}) => {
  const [bankruptcyComments, setBankruptcyComments] = useState("");
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [showBackModal, toggleShowBackModal] = useState(false);
  const [currentFormChanged, hasCurrentFormChanged] = useState(false);

  const handleToggleBackModal = (value) => {
    if (currentFormChanged) {
      toggleShowBackModal(value);
    } else {
      handleBack();
    }
  };
  const handleNext = () => {
    let tmpDRP = {
      ...tempBankruptcyDRP,
      bankruptcyComments: bankruptcyComments,
    };

    updateTempBankruptcyDRP(tmpDRP);
    updateBankruptcyDisclosureDRPs(tmpDRP);
    updateCCBForm(nextFormId);
    hasCurrentFormChanged(false);

    //wait/updateDRP stuff
  };
  const handleBack = () => {
    const tmpDRP = {
      ...tempBankruptcyDRP,
      bankruptcyComments,
    };
    if (hasSIPA(tmpDRP)) {
      updateCCBForm(CCB_FORM_ID.ADD_BANKRUPTCY_DRP_PAGE_5);
    } else if (hasCompromise(tmpDRP)) {
      updateCCBForm(CCB_FORM_ID.ADD_BANKRUPTCY_DRP_PAGE_4);
    } else {
      updateCCBForm(CCB_FORM_ID.ADD_BANKRUPTCY_DRP_PAGE_3);
    }
  };

  const handleChange = ({ target: { id, value } }) => {
    setBankruptcyComments(value);
    hasCurrentFormChanged(true);
  };

  useEffect(() => {
    setIsFormComplete(true);
  });
  useEffect(() => {
    if (tempBankruptcyDRP?.bankruptcyComments) {
      setBankruptcyComments(tempBankruptcyDRP?.bankruptcyComments);
      hasCurrentFormChanged(true);
      setIsFormComplete(true);
    }
  }, []);
  return (
    <div className="bankruptcy-form-wrapper">
      <br />
      <div className="row">
        <div className="col-md-12">
          <span id="bondAddDrpText" className="comments-label">
            You may use this field to provide a brief summary of the
            circumstances leading to the action as well as the current status or
            final disposition. (Optional)
          </span>
        </div>
      </div>
      <div style={{ paddingTop: "20px" }}>
        <textarea
          id="bondComments"
          className="form-control comments-label"
          value={bankruptcyComments}
          rows="3"
          maxLength={500}
          onChange={handleChange}
        ></textarea>
      </div>

      <NavigationButtons
        onBack={() => {
          handleToggleBackModal(true);
        }}
        onNext={handleNext}
        isLoading={false}
        isEndOfDRPForm={true}
        nxtbtnid={"bankruptcyAddDRPNext"}
        bckbtnid={"bankruptcyAddDRPBack"}
        nextBtnText="COMPLETE DRP"
      />
      <LostDataModal
        isOpen={showBackModal}
        handleClose={() => {
          handleToggleBackModal(false);
        }}
        handleProceed={handleBack}
      />
    </div>
  );
};
export default BankruptcyDisclosureComments;
